import { render, staticRenderFns } from "./RelationsTable.vue?vue&type=template&id=bfd6284c&scoped=true&"
import script from "./RelationsTable.vue?vue&type=script&lang=js&"
export * from "./RelationsTable.vue?vue&type=script&lang=js&"
import style0 from "./RelationsTable.vue?vue&type=style&index=0&id=bfd6284c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd6284c",
  null
  
)

export default component.exports